class Controller {
  constructor(Events, Sections, $stateParams) {
    "ngInject";

    this.Events = Events;
    this.filterEvent = this.Events.getFilterEvent("deductionplan");
    this.paginateEvent = this.Events.getPaginateEvent("deductionplan");
    this.sortEvent = this.Events.getSortEvent("deductionplan");
    this.addItemEvent = this.Events.getAddEvent("deductionplan");

    this.page = $stateParams.page;
    this.limit = $stateParams.limit;

    this.sections = Sections.plansSections;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/deductionplans/deductionplans.controller.js